<template>
  <div class="flex min-h-screen flex-col bg-blue-lighter">
    <main class="flex grow flex-col pb-20">
      <slot></slot>
    </main>
  </div>
</template>
